import React, { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import parse from 'html-react-parser';
import "./customModal.css"

const CustomModal = ({ payload, showModal, closeModalHandler }) => {
  const [show, setShow] = useState(true);
  const [primaryButtonType, setPrimaryButtonType] = useState("primary");
  const [showCancelButton, setShowCancelButton] = useState(true);

  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  useEffect(() => {
    if (payload.title === "Delete Activity") setPrimaryButtonType("danger");
    if (payload.title === "Reset Activity") setPrimaryButtonType("danger");
  },[payload.title]);

  useEffect(() => {
    if (payload.showCancelButton === false) setShowCancelButton(false);
  },[payload.showCancelButton]);

  return (
    <Modal
      show={showModal}
      onHide={closeModalHandler}
      keyboard={true}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {payload.title ? payload.title : "Warning"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div>
        <p>{parse(payload.bodyText)}</p>
        {payload.imageURL && (
          <img class="img-fluid" src={payload.imageURL} alt="alternative"/>
        )}
      </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={primaryButtonType}
          onClick={() => {
            payload.btnOkCb();
            handleClose();
          }}
        >
          {payload.okButtonText ? payload.okButtonText : "Accept"}
        </Button>
        {showCancelButton && 
        <Button
          variant="secondary"
          onClick={closeModalHandler}
        >
          Cancel
        </Button>}
      </Modal.Footer>
    </Modal>
  );
};

export default CustomModal;
